export const SettingsModal = {};